import { useState } from "react";
import { Checkbox } from "../../ui/checkbox";
import { ChevronDown, ChevronUp, BookImage } from "lucide-react";
import { formatMXN } from "../../../lib/whatsapp";
import { AlbumConfigurator } from "./AlbumConfigurator";

export const ExtrasStep = ({ form, toggleExtra, extras, albumConfig: config }) => {
  const [expanded, setExpanded] = useState(false);
  const hasAlbum = config.phase === "summary" && !!config.summary;

  return (
    <div className="space-y-4">
      <h3 className="font-serif-display text-2xl text-white mb-2">Extras disponibles</h3>

      <div className="border border-white/10 overflow-hidden" data-testid="quote-album-card">
        <button
          type="button"
          data-testid="quote-album-toggle"
          onClick={() => setExpanded((v) => !v)}
          className="w-full flex items-center justify-between px-4 py-3 hover:border-twp-gold/50 transition-colors"
        >
          <div className="flex items-center gap-3">
            <BookImage size={18} className="text-twp-gold" />
            <span className="text-white/80 text-sm text-left">
              Álbum impreso {hasAlbum && <span className="text-white/40">— {config.summary.typeLabel}, {config.summary.coverLabel}</span>}
            </span>
          </div>
          <div className="flex items-center gap-3">
            {hasAlbum && <span className="text-twp-gold text-sm">{formatMXN(config.summary.price)}</span>}
            {expanded ? <ChevronUp size={16} className="text-white/40" /> : <ChevronDown size={16} className="text-white/40" />}
          </div>
        </button>
        {expanded && (
          <div className="px-4 pb-4">
            <AlbumConfigurator config={config} />
          </div>
        )}
      </div>

      {extras.length === 0 ? (
        <p className="text-white/50 text-sm" data-testid="quote-extras-empty">No hay otros extras disponibles por el momento.</p>
      ) : (
        extras.map((extra) => (
          <label
            key={extra.id}
            data-testid={`quote-extra-${extra.id}`}
            className="flex items-center justify-between border border-white/10 px-4 py-3 cursor-pointer hover:border-twp-gold/50 transition-colors"
          >
            <div className="flex items-center gap-3">
              <Checkbox
                checked={form.extras.includes(extra.id)}
                onCheckedChange={() => toggleExtra(extra.id)}
                data-testid={`quote-extra-checkbox-${extra.id}`}
              />
              <span className="text-white/80 text-sm">{extra.label}</span>
            </div>
            <span className="text-twp-gold text-sm">{formatMXN(extra.price)}</span>
          </label>
        ))
      )}
    </div>
  );
};
